<template>
  <div class="flex-grow-1 d-flex flex-column" :class="{'page-transitioning': transitioning}">
    <v-main>
      <router-view v-slot="{ Component }" class="route-page">
        <transition
          :name="transitionName" mode="out-in"
          @after-enter="transitioning = false" @before-leave="transitioning = true"
        >
          <component :is="Component" />
        </transition>
      </router-view>
    </v-main>
  </div>
</template>

<script setup>
import { useRouteTransition } from '@/composables/useRouteTransition'

// Use route transition composable to replace the mixin
const { transitionName, transitioning } = useRouteTransition()

</script>

<style lang="scss" scoped>
// .page-transitioning {
//   overflow: hidden;
//   height: 100vh;
// }
</style>
